// @ts-nocheck
import { useCallback } from 'react'
import { ApolloError, useMutation } from '@apollo/client'
import { useWallet } from '@solana/wallet-adapter-react'
import { Button, Flex, Text } from '@radix-ui/themes'
import { SignoutMutation } from '__generated__/graphql'
import { LOG_OUT } from 'api/auth/logout'
import { clearSolanaWalletSession } from 'features/auth/utils/clear-solana-wallet-session'
import { DataTestIDs } from 'shared/constants'
import { DoorOutIcon } from 'shared/icons'
import { XyroLoading } from 'shared/ui'
import { notifyOnUnknownError } from 'shared/utils/notify-on-error'

export const Logout = () => {
  const [commitLogOut, { loading }] = useMutation<SignoutMutation>(LOG_OUT)
  const { disconnect } = useWallet()

  const handleLogOut = useCallback(async () => {
    commitLogOut()
      .then(async () => {
        await disconnect()
        clearSolanaWalletSession()
        location.reload()
      })
      .catch(e => notifyOnUnknownError(e as ApolloError))
  }, [commitLogOut, disconnect])

  return (
    <Button
      onClick={handleLogOut}
      variant={'ghost'}
      type={'button'}
      disabled={loading}
      size={'3'}
      mx={'3'}
      mt={'3'}
      data-testid={DataTestIDs.buttonLogOut}
    >
      <Flex
        align={'center'}
        gap={'2'}
        p={'1'}
      >
        <XyroLoading loading={loading}>
          <DoorOutIcon color='var(--white)' />
          <Text
            className='color-white'
            size={'2'}
          >
            {!loading ? 'Log out' : 'Logging out...'}
          </Text>
        </XyroLoading>
      </Flex>
    </Button>
  )
}
